import { BASE, TONE } from './SectionMessage.constants';
import type { SectionMessageProps } from './SectionMessage.types';

/** Full-width message that replaces a section's content: empty, not configured,
 *  no permission, failed to load. */
export const SectionMessage = ({ children, tone = 'info' }: SectionMessageProps) => (
	<p className={`${BASE} ${TONE[tone]}`}>{children}</p>
);
